import api from 'services/api';

/* The SurveyProps type represents the properties of a Survey, including its UUID, code, body, enabled, and buildingUuid. */
export type SurveyProps = {
  uuid?: string;
  code: string;
  body?: string;
  enabled?: boolean | string;
  buildingUuid: string;
};

/* The function `findAllSurveys` is an asynchronous function that makes a GET request to the `/apiv1/surveys/` endpoint and returns 
all the Surveys data from the response. */
const findAllSurveys = async () => {
  const response = await api.get<SurveyProps[]>('/apiv1/surveys/');
  return response?.data;
};

/* The function `findSurveyById` retrieves a Survey object from an API based on the provided UUID. */
const findSurveyById = async (uuid: string | undefined) => {
  const response = await api.get<SurveyProps>(`/apiv1/survey/${uuid}/`);
  return response?.data;
};

/* The function creates a new Survey by making a POST request to the '/apiv1/survey/' endpoint with the provided Survey data. */
const createSurvey = async (newSurvey: SurveyProps) => {
  const response = await api.post<SurveyProps>('/apiv1/survey/', newSurvey);
  return response?.data;
};

/* The function `updateSurvey` is an asynchronous function that updates a Survey using a PUT request to an API endpoint. */
const updateSurvey = async (uuid: string | undefined, updatedSurvey: SurveyProps) => {
  const response = await api.put<SurveyProps>(`/apiv1/survey/${uuid}/`, updatedSurvey);
  return response?.data;
};

const SurveyService = {
  findAllSurveys,
  findSurveyById,
  createSurvey,
  updateSurvey
};

export default SurveyService;
